import * as Yup from 'yup';

export const TherapyServiceSchema = Yup.object().shape({
  provider_name: Yup.string().trim().required().min(2),
  service_type: Yup.string().trim().required().min(2),
  hours: Yup.number().min(0).required(),
  frequency: Yup.string().trim().required(),
  is_parents_authorization_provided: Yup.boolean().required(),
  response_to_treatment: Yup.string().trim().required(),
  date_start: Yup.string().trim().required(),
  date_end: Yup.string().nullable().optional(),
  is_record_shared: Yup.string().when('is_parents_authorization_provided', {
    is: true,
    then: () => Yup.string().trim().required(),
    otherwise: () => Yup.string().nullable(),
  }),
});
